/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Parq_TitleInputs */

const en_us2_profile_editors_parq_title = /** @type {(inputs: Profile_Editors_Parq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before training, your health`)
};

const pt_br2_profile_editors_parq_title = /** @type {(inputs: Profile_Editors_Parq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de treinar, sua saúde`)
};

const es_419_profile_editors_parq_title = /** @type {(inputs: Profile_Editors_Parq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de entrenar, tu salud`)
};

const pt_pt2_profile_editors_parq_title = /** @type {(inputs: Profile_Editors_Parq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de treinar, a tua saúde`)
};

const fr_fr2_profile_editors_parq_title = /** @type {(inputs: Profile_Editors_Parq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant de t'entraîner, ta santé`)
};

const de_de2_profile_editors_parq_title = /** @type {(inputs: Profile_Editors_Parq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor dem Training: deine Gesundheit`)
};

const it_it2_profile_editors_parq_title = /** @type {(inputs: Profile_Editors_Parq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima di allenarti, la tua salute`)
};

/**
* | output |
* | --- |
* | "Before training, your health" |
*
* @param {Profile_Editors_Parq_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_parq_title = /** @type {((inputs?: Profile_Editors_Parq_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Parq_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_parq_title(inputs)
	if (locale === "es-419") return es_419_profile_editors_parq_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_parq_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_parq_title(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_parq_title(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_parq_title(inputs)
	return en_us2_profile_editors_parq_title(inputs)
});
export { profile_editors_parq_title as "profile-editors.parq_title" }